import { restore, createEvent } from 'effector';
import { useUnit } from 'effector-react';

export const setShowLoader = createEvent<boolean>('SET_SHOW_LOADER');
export const $showLoader = restore(setShowLoader, false);
export const useShowLoader = () => useUnit($showLoader);
